<template>
  <span>
    <v-dialog
      persistent
      fullscreen
      v-model="ableToPlay"
      width="800"
      scrollable
      color="white"
    >
      <v-card>
        <v-card-text>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              depressed
              @click="ableToPlay = false"
              small
              color="red lighten-5 red--text"
              >close
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <center>
            <iframe
              :src="`${spin_server_url}?email=${encodeURIComponent(
                user.email
              )}&wheelId=CSW2026&name=${
                encodeURIComponent(user.first_name) +
                ' ' +
                encodeURIComponent(user.last_name)
              }&phoneNumber=${encodeURIComponent(user.phone_number)}`"
              class="ma-0"
              title="Built Wheel of Fortune"
              style="
                border: 0;
                margin: 0;
                border: none !important;
                width: 100%;
                height: 100%;
              "
            ></iframe>
          </center>
          <v-card-actions>
            <v-btn
              @click="ableToPlay = false"
              color="green"
              rounded
              dark
              block
              x-large
              >Done</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { defineComponent } from "vue";
import { getAccessToken } from "../../utils";
import axios from "axios";

export default defineComponent({
  name: "fortuneWheel",
  data() {
    return {
      ableToPlay: false,
    };
  },
  computed: {
    token() {
      return getAccessToken();
    },
    user() {
      return this.$store.state.user.user_infor;
    },
    spin_server_url() {
      return "https://built-spin-the-wheel.vercel.app/";
    },
  },
  mounted() {
    if (this.user.is_admin) {
      axios
        .get(
          `${
            this.spin_server_url
          }api/check-eligibility?wheelId=CSW2026&email=${encodeURIComponent(
            this.user.email
          )}`
        )
        .then((res) => {
          const eligibility = res.data;
          this.ableToPlay = eligibility.eligible;
        });
    }
  },
});
</script>

<style scoped>
svg {
  display: block;
  font: 3rem "Montserrat";
  width: auto;
  height: 50px;
  margin: 0 auto;
}

.text-copy {
  fill: none;
  stroke: white;
  stroke-dasharray: 6% 29%;
  stroke-width: 5px;
  stroke-dashoffset: 0%;
  animation: stroke-offset 6s infinite linear;
}

.text-copy:nth-child(1) {
  stroke: #4d163d;
  animation-delay: -1;
}

.text-copy:nth-child(2) {
  stroke: #840037;
  animation-delay: -2s;
}

.text-copy:nth-child(3) {
  stroke: #bd0034;
  animation-delay: -3s;
}

.text-copy:nth-child(4) {
  stroke: #bd0034;
  animation-delay: -4s;
}

.text-copy:nth-child(5) {
  stroke: #fdb731;
  animation-delay: -5s;
}

@keyframes stroke-offset {
  100% {
    stroke-dashoffset: -35%;
  }
}
</style>
